// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper – prevents body scroll, only content scrolls */
.dashboard-wrapper {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Layout */
#layoutSidenav {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  background: var(--main-bg);
}

#layoutSidenav_nav {
  width: var(--sidebar-width);
  height: 100%;
  flex-shrink: 0;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-right: 1px solid var(--sidebar-border);
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.04);
  transition: width 0.2s ease, transform 0.2s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

#layoutSidenav.sidebar-collapsed #layoutSidenav_nav {
  width: 0;
  min-width: 0;
}

.layoutSidenav_content {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  overflow-anchor: none; /* Prevents scroll jump when child content re-renders */
  background: var(--main-bg);
  -webkit-overflow-scrolling: touch;
}

.leftside_items {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.sidebar-logo {
  flex-shrink: 0;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--sidebar-border);
  background: #fff;
}

.sidebar-logo a {
  display: flex;
  align-items: center;
  transition: opacity 0.2s;
}

.sidebar-logo a:hover {
  opacity: 0.85;
}

.sidebar-logo img {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.toggle_menu {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--main-bg);
  color: var(--sidebar-text);
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.toggle_menu:hover {
  background: var(--sidebar-active);
  color: var(--primary);
}

.toggle_menu.close_btn {
  display: none;
}

.navi_sidebar {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0.85rem 0;
  position: relative;
}

.responsive_scrool {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 0.65rem;
  -webkit-overflow-scrolling: touch;
}

.responsive_scrool::-webkit-scrollbar {
  width: 6px;
}

.responsive_scrool::-webkit-scrollbar-track {
  background: transparent;
}

.responsive_scrool::-webkit-scrollbar-thumb {
  background: var(--sidebar-border);
  border-radius: 3px;
}

.responsive_scrool::-webkit-scrollbar-thumb:hover {
  background: #cbd5e1;
}

.list-unstyled li {
  margin-bottom: 2px;
}

.sidebar-section-label {
  padding: 0.85rem 1rem 0.4rem;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--sidebar-text-muted);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.sidebar-feature-badge {
  margin-left: auto;
  padding: 0.15rem 0.45rem;
  font-size: 0.6rem;
  font-weight: 700;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.sidebar-feature-badge--on {
  background: rgba(34, 197, 94, 0.2);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.sidebar-feature-badge--off {
  background: rgba(148, 163, 184, 0.25);
  color: #64748b;
  border: 1px solid rgba(148, 163, 184, 0.4);
}

.sidebar-feature-badge--maintenance {
  background: rgba(239, 68, 68, 0.15);
  color: #dc2626;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.sidebar-feature-badge--active {
  background: rgba(34, 197, 94, 0.2);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.navi_sidebar a .sidebar-feature-badge {
  margin-left: 0.35rem;
}

.navi_sidebar a .sidebar-pending-badge + .sidebar-feature-badge {
  margin-left: 0.35rem;
}

.navi_sidebar a {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.7rem 1rem;
  font-size: 0.9rem;
  color: var(--sidebar-text);
  border-radius: var(--radius-sm);
  transition: background 0.2s, color 0.2s;
  position: relative;
}

.navi_sidebar a::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 0;
  background: var(--primary);
  border-radius: 0 3px 3px 0;
  transition: height 0.2s;
}

.navi_sidebar a:hover {
  background: var(--sidebar-active);
  color: var(--primary);
}

.navi_sidebar a:hover::before {
  height: 60%;
}

.navi_sidebar li.active a {
  background: rgba(15, 118, 110, 0.08);
  color: var(--primary);
  font-weight: 600;
}

.navi_sidebar li.active a::before {
  height: 60%;
}

.navi_sidebar a i {
  width: 1.25rem;
  text-align: center;
  font-size: 0.95rem;
  opacity: 0.9;
}

.sidebar-pending-badge {
  margin-left: auto;
  padding: 0.25rem 0.55rem;
  font-size: 0.7rem;
  font-weight: 700;
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
  color: #fff;
  border-radius: 20px;
  min-width: 22px;
  text-align: center;
  box-shadow: 0 1px 4px rgba(220, 38, 38, 0.35);
}

.logout_btn {
  flex-shrink: 0;
  padding: 0.85rem 1rem;
  margin-top: auto;
  border-top: 1px solid var(--sidebar-border);
  background: linear-gradient(180deg, #fff5f5 0%, #fff 100%);
}

.logout_btn a {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 50%, #f87171 100%);
  border-radius: var(--radius-sm);
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.35);
  transition: transform 0.2s, box-shadow 0.2s;
}

.logout_btn a:hover {
  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 50%, #ef4444 100%);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.45);
  transform: translateY(-1px);
}

@media (max-width: 992px) {
  #layoutSidenav_nav {
    position: fixed;
    left: 0;
    top: 60px;
    bottom: 0;
    z-index: 90;
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.12);
  }

  #layoutSidenav.sidebar-collapsed #layoutSidenav_nav {
    transform: translateX(-100%);
    width: var(--sidebar-width);
  }

  .toggle_menu.close_btn {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Layout/DashboardPage.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,cAAc;EACd,6DAA6D;EAC7D,6CAA6C;EAC7C,0CAA0C;EAC1C,gDAAgD;EAChD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB,EAAE,uDAAuD;EAC9E,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2CAA2C;EAC3C,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,0EAA0E;EAC1E,+BAA+B;EAC/B,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,0EAA0E;EAC1E,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;IACf,OAAO;IACP,SAAS;IACT,SAAS;IACT,WAAW;IACX,0CAA0C;EAC5C;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Wrapper – prevents body scroll, only content scrolls */\n.dashboard-wrapper {\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Layout */\n#layoutSidenav {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  background: var(--main-bg);\n}\n\n#layoutSidenav_nav {\n  width: var(--sidebar-width);\n  height: 100%;\n  flex-shrink: 0;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  border-right: 1px solid var(--sidebar-border);\n  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.04);\n  transition: width 0.2s ease, transform 0.2s ease;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n#layoutSidenav.sidebar-collapsed #layoutSidenav_nav {\n  width: 0;\n  min-width: 0;\n}\n\n.layoutSidenav_content {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  overflow-anchor: none; /* Prevents scroll jump when child content re-renders */\n  background: var(--main-bg);\n  -webkit-overflow-scrolling: touch;\n}\n\n.leftside_items {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.sidebar-logo {\n  flex-shrink: 0;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--sidebar-border);\n  background: #fff;\n}\n\n.sidebar-logo a {\n  display: flex;\n  align-items: center;\n  transition: opacity 0.2s;\n}\n\n.sidebar-logo a:hover {\n  opacity: 0.85;\n}\n\n.sidebar-logo img {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n}\n\n.toggle_menu {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: var(--main-bg);\n  color: var(--sidebar-text);\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.toggle_menu:hover {\n  background: var(--sidebar-active);\n  color: var(--primary);\n}\n\n.toggle_menu.close_btn {\n  display: none;\n}\n\n.navi_sidebar {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 0.85rem 0;\n  position: relative;\n}\n\n.responsive_scrool {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 0.65rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n.responsive_scrool::-webkit-scrollbar {\n  width: 6px;\n}\n\n.responsive_scrool::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.responsive_scrool::-webkit-scrollbar-thumb {\n  background: var(--sidebar-border);\n  border-radius: 3px;\n}\n\n.responsive_scrool::-webkit-scrollbar-thumb:hover {\n  background: #cbd5e1;\n}\n\n.list-unstyled li {\n  margin-bottom: 2px;\n}\n\n.sidebar-section-label {\n  padding: 0.85rem 1rem 0.4rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--sidebar-text-muted);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.sidebar-feature-badge {\n  margin-left: auto;\n  padding: 0.15rem 0.45rem;\n  font-size: 0.6rem;\n  font-weight: 700;\n  border-radius: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.sidebar-feature-badge--on {\n  background: rgba(34, 197, 94, 0.2);\n  color: #16a34a;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.sidebar-feature-badge--off {\n  background: rgba(148, 163, 184, 0.25);\n  color: #64748b;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n}\n\n.sidebar-feature-badge--maintenance {\n  background: rgba(239, 68, 68, 0.15);\n  color: #dc2626;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.sidebar-feature-badge--active {\n  background: rgba(34, 197, 94, 0.2);\n  color: #16a34a;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.navi_sidebar a .sidebar-feature-badge {\n  margin-left: 0.35rem;\n}\n\n.navi_sidebar a .sidebar-pending-badge + .sidebar-feature-badge {\n  margin-left: 0.35rem;\n}\n\n.navi_sidebar a {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.7rem 1rem;\n  font-size: 0.9rem;\n  color: var(--sidebar-text);\n  border-radius: var(--radius-sm);\n  transition: background 0.2s, color 0.2s;\n  position: relative;\n}\n\n.navi_sidebar a::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 0;\n  background: var(--primary);\n  border-radius: 0 3px 3px 0;\n  transition: height 0.2s;\n}\n\n.navi_sidebar a:hover {\n  background: var(--sidebar-active);\n  color: var(--primary);\n}\n\n.navi_sidebar a:hover::before {\n  height: 60%;\n}\n\n.navi_sidebar li.active a {\n  background: rgba(15, 118, 110, 0.08);\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.navi_sidebar li.active a::before {\n  height: 60%;\n}\n\n.navi_sidebar a i {\n  width: 1.25rem;\n  text-align: center;\n  font-size: 0.95rem;\n  opacity: 0.9;\n}\n\n.sidebar-pending-badge {\n  margin-left: auto;\n  padding: 0.25rem 0.55rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);\n  color: #fff;\n  border-radius: 20px;\n  min-width: 22px;\n  text-align: center;\n  box-shadow: 0 1px 4px rgba(220, 38, 38, 0.35);\n}\n\n.logout_btn {\n  flex-shrink: 0;\n  padding: 0.85rem 1rem;\n  margin-top: auto;\n  border-top: 1px solid var(--sidebar-border);\n  background: linear-gradient(180deg, #fff5f5 0%, #fff 100%);\n}\n\n.logout_btn a {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.7rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #dc2626 0%, #ef4444 50%, #f87171 100%);\n  border-radius: var(--radius-sm);\n  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.35);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.logout_btn a:hover {\n  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 50%, #ef4444 100%);\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.45);\n  transform: translateY(-1px);\n}\n\n@media (max-width: 992px) {\n  #layoutSidenav_nav {\n    position: fixed;\n    left: 0;\n    top: 60px;\n    bottom: 0;\n    z-index: 90;\n    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.12);\n  }\n\n  #layoutSidenav.sidebar-collapsed #layoutSidenav_nav {\n    transform: translateX(-100%);\n    width: var(--sidebar-width);\n  }\n\n  .toggle_menu.close_btn {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
